import { PageTitleLong } from '@zoopla-eng/zds-components/headings';
import { styled } from '@zoopla-eng/zds-components/themes';

export const StyledTitle = styled(PageTitleLong, {
    fontGroup: 'teapot'
});
